import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from 'app/routes/history';
import _ from 'lodash';
import {
  IPaymentEventsSelector,
  IForfeitsSelector,
  ITeamsSelector,
} from 'app/types/selector';

import { changeState } from '@teammo/teammo-general-utils';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';
import SectionGroup from 'app/components/general/SectionGroup';
import Button from 'app/components/general/Button';

import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as forfeitsActions from 'app/ducks/forfeits/actions';
import * as groupsActions from 'app/ducks/groups/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as forfeitsSelectors from 'app/ducks/forfeits/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    forfeits: forfeitsSelectors.getForfeits(state),
    organisations: organisationsSelectors.getOrganisations(state),
    groups: groupsSelectors.getGroups(state),
    teams: teamsSelectors.getTeams(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(paymentEventsActions, forfeitsActions, groupsActions);

interface IConfirmZeroDollarForfeitCovidProps {
  paymentEvents: IPaymentEventsSelector;
  forfeits: IForfeitsSelector;
  teams: ITeamsSelector;
  match: any;
  actions: any;
}

interface IConfirmZeroDollarForfeitCovidState {
  reason: string;
  errors: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class ConfirmZeroDollarForfeitCovid extends React.Component<
IConfirmZeroDollarForfeitCovidProps,
IConfirmZeroDollarForfeitCovidState
> {
  static defaultProps: IConfirmZeroDollarForfeitCovidProps = {
    paymentEvents: {},
    forfeits: {},
    teams: {},
    match: undefined,
    actions: undefined,
  };

  state = {
    reason: '',
    errors: {},
  };

  componentDidMount = () => {
    if (this.props.match.params.forfeitId) {
      this.props.actions.getForfeit(
        this.props.match.params.forfeitId,
      );
    }
  };

  handleChange = (e) => {
    e.persist();
    this.setState((previousState) => changeState(previousState, e.target));
  };

  handleSubmit = () => {
    const { currentPaymentEvent } = this.props.paymentEvents;
    const { currentGroup } = this.props.groups;
    if (!_.isEmpty(currentPaymentEvent)) {
      const forfeitPayload = {
        id: this.props.match.params.forfeitId,
        status: 'paid',
      };
      this.props.actions.updateForfeit(forfeitPayload);
    }
  };

  render(): React.ReactNode {
    const { currentForfeit } = this.props.forfeits;
    const matchCardData = paymentEventsSelectors.getPaymentEventForMatchCard(
      currentForfeit.paymentEvent,
      currentForfeit.group?.id,
    );
    return (
      <div>
        <div>
          {!_.isEmpty(matchCardData) && (
            <div className="row">
              <div className="col">
                <PaymentCardMin {...matchCardData} truncated />
              </div>
            </div>
          )}
          <div className="row with-margin-top">
            <div className="col col-xl-8">
              There is no fee for this forfeit as per your association's policy. Once confirmed, notifications will be sent to the association and your opposition.
              <br />
              <br />
              Please only confirm this forfeit if it is directly related to COVID and you're the team manager. Your association will review each forfeit to ensure they are valid.
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col">
              <SectionGroup title="Forfeit Summary">
                <div className="row">
                  <div className="col text-dark-grey">
                    <span className="text-weight-medium-bold">Team: </span>
                    {currentForfeit.group?.name}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                <div className="row">
                  <div className="col col-8 text-dark-grey d-flex">
                    <div>
                      <div className="number-label">1</div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      Forfeit - COVID:
                      {' '}
                      {currentForfeit.reason}
                    </div>
                  </div>
                  <div className="col col-4 d-flex justify-content-end text-right text-dark-grey align-items-center">
                    $0.00
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                <div className="row">
                  <div className="col text-black text-weight-medium-bold">
                    Total Amount
                  </div>
                  <div className="col text-right text-dark-grey text-weight-medium-bold">
                    $0.00
                  </div>
                </div>
                <div className="row with-margin-top">
                  <div className="col text-right">
                    <Button
                      className="btn-success"
                      type="submit"
                      isLoading={this.props.forfeits.isSaving}
                      onClick={this.handleSubmit}
                    >
                      Confirm
                    </Button>
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
